import {Env} from "@ok/common/utils/env";

// В логер можно писать любые данные
// https://jira.odkl.ru/browse/MOL-14411
// eslint-disable-next-line  @typescript-eslint/no-explicit-any
type ILoggerParams = any[];

type ILoggerFn = (...args: ILoggerParams) => void;

export interface ILogger {
    debug: ILoggerFn;
    warn: ILoggerFn;
    info: ILoggerFn;
    error: ILoggerFn;
}

declare const global: {
    logger: ILogger;
};

/**
 * Этот модуль нужен чтобы отправлять в консоль ошибки на сервере и на клиенте через один интерфейс.
 * Не использовать его для логирования, графиков или еще чего-то.
 * @see one-desktop/src/one/desktop/react/graalvm/JsLogger.java
 */
export const Logger = {
    debug: (...args: ILoggerParams) => {
        if (Env.isServerRendering) {
            global.logger?.debug(args);
        } else {
            window.OK?.react.logging.info("Debug:", ...args);
        }
    },
    warn: (...args: ILoggerParams) => {
        if (Env.isServerRendering) {
            global.logger?.warn(args);
        } else {
            window.OK?.react.logging.info("Warn:", ...args);
        }
    },
    info: (...args: ILoggerParams) => {
        if (Env.isServerRendering) {
            global.logger?.info(args);
        } else {
            window.OK?.react.logging.info("Info:", ...args);
        }
    },
    error: (...args: ILoggerParams) => {
        if (Env.isServerRendering) {
            global.logger?.error(args);
        } else {
            window.OK?.react.logging.info("Error:", ...args);
        }
    }
};
